import React, { useEffect, useRef } from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import { useSelector } from 'react-redux'
import UserType from 'src/model/user-types'
import { CoreButton } from 'src/components/core'
import { track } from '@amplitude/analytics-browser'
import { HtmlToPdf } from '@minicoursegenerator/html-to-pdf-converter'

const PdfCourse = props => {
  const { classes, me } = props
  const entity = useSelector(state => state.course.entity)
  const userControl = UserType[me.userRoleId]

  const isBasicUser =
    userControl == 'Basic' ||
    userControl == 'AppSumo (Tier 1)' ||
    UserType.isTrialEquivalent(userControl)

  const upgradeBannerTrackedRef = useRef(false)
  useEffect(() => {
    if (isBasicUser && !upgradeBannerTrackedRef.current) {
      upgradeBannerTrackedRef.current = true
      track('upgrade_banner_seen', { type: 'pdf_download' })
    }
  }, [isBasicUser])

  if (!entity) {
    return null
  }

  const htmlContent =
    entity?.cardDtos?.map(card => card.text || '').join('') || ''

  return (
    <div className={classes.customDomain__root}>
      {isBasicUser ? (
        <>
          <Typography fontSize="14px" fontWeight={400}>
            You can export your course as a PDF for easy sharing and
            printing.{' '}
          </Typography>
          <img src={'/assets/Upgrade.png'} alt="rocket!" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography fontSize="16px" fontWeight={500}>
              Upgrade to Plus Plan
            </Typography>
            <div className={classes.badge}>
              <Typography
                fontSize={'11px'}
                fontWeight={500}
                style={{ color: '#015FFB' }}
              >
                Plus
              </Typography>
            </div>
          </div>
          <Typography fontSize="14px" fontWeight={400}>
            Upgrade to the Plus Plan to download as PDF your courses and
            access exclusive features.
          </Typography>
          <CoreButton
            fullWidth
            onClick={() => {
              window.location.href = '/pricing'
            }}
          >
            Upgrade to Plus
          </CoreButton>
        </>
      ) : (
        <>
          <Typography className={classes.embedInstructionText}>
            You can export your course as a PDF for easy sharing and
            printing.
          </Typography>
          <div className={classes.pdfContainer}>
            <img
              src="/assets/pdf-document-svgrepo-com_1.svg"
              alt="pdf-icon"
              className={classes.pdfIcon}
            />
            <Typography className={classes.fileName}>
              {entity?.name + '.pdf'}
            </Typography>
          </div>
          <HtmlToPdf
            html={htmlContent}
            fontFamily="Lato"
            fontUrl="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap"
            fileName={(entity?.name || 'document') + '.pdf'}
          >
            {({ download, isGenerating }) => (
              <button
                className={classes.downloadButton}
                onClick={() => {
                  track('course_downloaded_as_pdf')
                  download()
                }}
                disabled={isGenerating}
              >
                {isGenerating ? 'Creating...' : 'Download file'}
              </button>
            )}
          </HtmlToPdf>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(PdfCourse)
